<script>
import VueCharts from 'vue-chartjs'
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'BarChart',
  props: ['chartData', 'options'],
  methods: {
    updateRendering () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    // Overwriting base render method with actual data.
    // this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/charts/BarChart.vue